import React, {useState, useEffect} from "react";
import { styled, css } from "@mui/system";
import { Modal as BaseModal } from "@mui/base/Modal";
import CloseIcon from "@mui/icons-material/Close";

export const PhotoModal = ({ open, setOpen, image, size }) => {
  const handleClose = () => setOpen(false);
  const [imageDimensions, setImageDimensions] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const image = new Image();
    image.src = image;

    image.onload = () => {
      const { width, height } = image;
      const aspectRatio = width / height;

      // Calculate dimensions respecting maxWidth and maxHeight
      const calculatedWidth = Math.min(width, 300);
      const calculatedHeight = Math.min(calculatedWidth / aspectRatio, 300);

      setImageDimensions({ width: calculatedWidth, height: calculatedHeight });
    };
  }, [image]);

  const Backdrop = React.forwardRef((props, ref) => {
    const { open, ...other } = props;
    return <div ref={ref} {...other} />;
  });
  
  const Modal = styled(BaseModal)`
    position: fixed;
    z-index: 1300;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  `;
  
  const StyledBackdrop = styled(Backdrop)`
    z-index: -1;
    position: fixed;
    inset: 0;
    background-color: rgb(0 0 0 / 0.5);
    -webkit-tap-highlight-color: transparent;
  `;
  
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: size === 'small' ? 400 : '100vw',
    maxWidth: size === 'small' ? 600 : '100vw',
    height: size === 'small' ? '60vh' : '90vh',
    maxHeight: size === 'small' ? '60vh' : '90vh',
    background: 'white',
    borderRadius: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: size === 'small' ? 0 : 24,
  };
  
  const ModalContent = styled("div")(
    ({ theme }) => css`
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 8px;
      overflow: hidden;
      background-color: #f1ecec;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgb(0 0 0 / 0.5);
      padding: 24px;
      color: black;
      width: 100%;
      height: 100%;
      max-width: 100vw;
      max-height: 100vh;
  
      & .image {
          maxWidth: '100%', 
          maxHeight: '100%', 
          width: ${imageDimensions.width},
          height: ${imageDimensions.height},
      }
  
      & .icon-container {
        position: absolute;
        top: 5px;
        right: 10px;
      }
      & .close-icon {
        width: 40px;
        height: 40px;
      }
    `
  );

  return (
    <div>
      <Modal
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: StyledBackdrop }}
      >
        <ModalContent sx={style}>
          <div className="icon-container">
            <CloseIcon className="close-icon" onClick={handleClose} />
          </div>

          <img
            className="image"
            src={image}
            style={{
              maxWidth: '100%',
              maxHeight: '100%',
              width: 'auto',
              height: 'auto',
              display: 'block',
              margin: '0 auto',
              borderRadius: 12,
              boxShadow: '0 4px 12px rgb(0 0 0 / 0.5)',
              objectFit: 'contain',
            }}
          />
        </ModalContent>
      </Modal>
    </div>
  );
};
